import axios from "axios";

import type { tBooking } from "../types";

export const getBookings = async (): Promise<tBooking[]> => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_BOOKING_INVOKE_URL}/bookings`,
  );

  return data;
};
